import { useState } from 'react';
import { Check, X } from 'lucide-react';

export function RolePopup({ isOpen, onClose, onContinue }) {
    const [selectedHiringRole, setSelectedHiringRole] = useState(null);

    if (!isOpen) return null;

    const handleContinue = () => {
        if (selectedHiringRole) {
            onContinue(selectedHiringRole);
        }
    };

    const options = [
        { value: "organization", label: "I’m an Organization" },
        { value: "sme", label: "I’m an SME" }
    ];

    return (
        <div className="fixed inset-0 bg-gray-100/50 overflow-y-auto h-full w-full flex justify-center items-center z-50">
            <div className="relative p-8 w-full max-w-md shadow-lg rounded-2xl bg-white dark:bg-gray-800 mx-4">
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300">
                    <X size={24} />
                </button>
                <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 tracking-tighter mb-6 text-center">Join as an Organization or SME</h3>
                <div className="flex flex-col gap-y-4">
                    {options.map(option => (
                        <label key={option.value} className="relative cursor-pointer">
                            <button
                                onClick={() => setSelectedHiringRole(option.value)}
                                className="w-full h-[80px] flex items-center justify-center rounded-lg border-2 p-4 shadow-sm transition-all duration-200 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700"
                            >
                                <span className="font-bold text-gray-900 dark:text-gray-100 text-lg tracking-tighter">{option.label}</span>
                                <span className={`absolute top-2 right-2 w-6 h-6 ${selectedHiringRole === option.value ? "bg-blue-700" : "bg-white dark:bg-gray-800"} border border-gray-400 dark:border-gray-500 rounded-full flex items-center justify-center transition-all duration-200`}>
                                    {selectedHiringRole === option.value && <Check className="w-4 h-4 text-white" strokeWidth={3} />}
                                </span>
                            </button>
                        </label>
                    ))}
                </div>
                <div className="mt-6 flex justify-center">
                    <button onClick={handleContinue} disabled={!selectedHiringRole} className="w-full h-[48px] text-blue-700 text-[14px] font-semibold hover:text-blue-500 disabled:text-blue-300 disabled:cursor-not-allowed transition-colors">
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
}